import cns from '../../assets/img/logos/cns-t.png';
import bns from '../../assets/img/logos/bns-t.png';
import ci from '../../assets/img/logos/ci-t.png';
import bi from '../../assets/img/logos/bi-t.png';

export default { cns, bns, ci, bi };
